import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    text: {
      primary: '#000000',
    },
    background: {
      default: '#f4f4f4',
      paper: '#ffffff',
    },
    action: {
      selected: '#e0e0e0',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial',
    fontSize: 14,
    h1: {
      fontSize: '1.5rem',
      lineHeight: 1.2,
      fontWeight: 400,
      color: '#000000',
      margin: '0 0 .5rem',
    },
    h2: {
      fontSize: '1.4rem',
      lineHeight: 1.2,
      fontWeight: 400,
      color: '#37373C',
      margin: '0 0 .5rem',
    },
    h3: {
      fontSize: '1.25rem',
      lineHeight: 1.2,
      fontWeight: 400,
      color: '#37373C',
      margin: '0 0 .5rem',
    },
    h4: {
      fontSize: '1.1rem',
      lineHeight: 1.2,
      fontWeight: 400,
      color: '#37373C',
      margin: '0 0 .5rem',
    },
    h5: {
      fontSize: '1rem',
      lineHeight: 1.2,
      fontWeight: 400,
      color: '#37373C',
      margin: '0 0 .5rem',
    },
    h6: {
      fontSize: '.875rem',
      lineHeight: 1.2,
      fontWeight: 400,
      color: '#37373C',
      margin: '0 0 .5rem',
    },
    body1: {
      fontSize: '1.142rem',
    },
  },

  components: {
    MuiTypography: {
      variants: [
        {
          props: { variant: 'pageHeader' },
          style: {
            fontSize: '1.412rem',
            fontWeight: 700,
            fontStyle: 'normal',
            color: '#000000',
            lineHeight: '2.071rem',
            fontFamily: 'Seravek',
          },
        },
        {
          props: { variant: 'appName' },
          style: {
            fontSize: '1.2rem',
            fontWeight: 300,
            fontStyle: 'normal',
            color: '#ffffff',
            lineHeight: '2.071rem',
            fontFamily: 'Seravek',
          },
        },
      ],
      styleOverrides: {
        h6: {
          margin: 'auto',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: 'white',
          width: 300,
          paddingRight: 5,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'primary.dark',
          color: 'secondary.contrastText',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 1, // Replaced theme.spacing(1) with a constant value.
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          color: 'inherit',
        },
      },
    },
  },
});

export default theme;
